import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Element } from "react-scroll";

import Map from './Map';

import { withStyles } from '@material-ui/core/styles';

import { pushDatatoServer } from "../../utils/RequestsHelper";

import classnames from "classnames";

import ReCAPTCHA from "react-google-recaptcha";

import ContactoSmall from '../../contactos/ContactoSmall';

import axios from 'axios';

const recaptchaRef = React.createRef();

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  cssRoot: {
    color: '#ffffff',
    backgroundColor: '#529a76',
    '&:hover': {
      backgroundColor: '#417A5E',
    },
    marginTop: '32px',
    textTransform: 'capitalize',
    fontSize: '18px',
    fontFamily: 'Pt Sans'
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  cssLabel: {
    '&$cssFocused': {
      color: '#417A5E',
    },
  },
  cssFocused: {},
  cssUnderline: {
    '&:after': {
      borderBottomColor: '#417A5E',
    },
    '&:hover': {
      borderBottomColor: '#417A5E',
    },
  }
});

class Contacts extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      subject: '',
      email: '',
      message: '',
      recaptchaValid: false,
      contactos: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount(){
    this.loadContactos();
}

  loadContactos = async () => {
    let res = {};
    try {
      res = await axios.get("/api/contactos", {
        params: {
          frontPage: true,
        },
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }

    let contactos = [];

    if(res.data !== undefined && res.data.arrayContactos !== undefined) {
      contactos = res.data.arrayContactos;
    }
    

    this.setState({ contactos });
  };

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    alert('An essay was submitted: ' + this.state.value);
    event.preventDefault();
  }

  renderMandatoryMessage = (field) =>{
    if(this.state[field] === true){
        return(
            <span className="alert-danger ml-6">Campo obrigatório</span>
        )
    }
  }

  renderEmailInvalid = (field, message) =>{
    if(this.state[field] === true){
        return(
            <span className="alert-danger ml-6">Email submetido inválido</span>
        )
    }
  }

  

  render() {

    const items = this.state.contactos.map(function (item) {
      return <ContactoSmall contacto={item} key={item.identifier}></ContactoSmall>;
    });

    return (
        <section id="contactos">
        <Element name="contactosElement" />

        <div className="container">
          <h1>Contactos</h1>
          
          <div className="row">
            <div className="col-12">
              <Map></Map>
            </div>
            

            <div className="col-12 col-md-8">
              <div className="contact-info">
                <p>Junta de Freguesia do Sabugueiro,<br></br>
                    Largo da Sardeira<br></br>
                    6270-151 Sabugueiro</p>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="contact-info">
                <p> 238314619 / 913729666</p>
              </div>
            </div>

          </div>

          <p className="section-sub-title">Telefones Úteis</p>
          
          <div id="useful-contacts" className="row">
            {items}
          </div>

          <div className="row padding-top-contact">
            <div className="col-6">
              <p className="contact-us-text">Não seja um estranho na aldeia!<br></br>
                Contacte-nos!</p>
            </div>


            <div className="col-6 col-md-4">
              <p className="labels">Nome{this.renderMandatoryMessage("nameMissing")}</p>
              <input
                className={classnames(
                  "input-form",
                  "input-inscricao",
                  "input-mensagem",
                  this.state.isNameValid === false ? "bad-form" : ""
                )}
                type="text"
                name="name"
                value={this.state.name}
                placeholder="Nome"
                onChange={this.handleChange}
              />
            
              <p className="labels">Assunto{this.renderMandatoryMessage("subjectMissing")}</p>
              <input
                className={classnames(
                  "input-form",
                  "input-inscricao",
                  "input-mensagem",
                  this.state.isSubjectValid === false ? "bad-form" : ""
                )}
                type="text"
                name="subject"
                value={this.state.subject}
                placeholder="Assunto"
                onChange={this.handleChange}
              />
            
              <p className="labels">Email{this.renderMandatoryMessage("emailMissing")} {this.renderEmailInvalid("emailInvalid")}</p>
              <input
                className={classnames(
                  "input-form",
                  "input-inscricao",
                  "input-mensagem",
                  this.state.isEmailValid === false ? "bad-form" : ""
                )}
                type="text"
                name="email"
                value={this.state.email}
                placeholder="O seu e-mail"
                onChange={this.handleChange}
              />
            
              <p className="labels">Mensagem{this.renderMandatoryMessage("mensagemMissing")} </p>
              <textarea
                className={classnames(
                  "input-form",
                  "input-inscricao",
                  "input-mensagem",
                  "textarea-mensagem",
                  this.state.isMensagemValid === false ? "bad-form" : ""
                )}
                rows="7"
                placeholder="Mensagem"
                name="mensagem"
                value={this.state.mensagem}
                onChange={this.handleChange}
              ></textarea>
              
              <div className="recaptcha-mobile">
                  
                <ReCAPTCHA
                  ref={recaptchaRef}
                  size="compact"
                  onChange={this.captchaClicked}
                  sitekey="6LejQrUUAAAAAHrlOlpV6xHP-yMOFkQX65iTnoM5"
                />

              </div>

              <div className="recaptcha-bigger">
                <ReCAPTCHA
                ref={recaptchaRef}
                size="normal"
                onChange={this.captchaClicked}
                sitekey="6LejQrUUAAAAAHrlOlpV6xHP-yMOFkQX65iTnoM5"
              />
              </div>
              

                

              <div className="botoes-inscricao">
                {this.state.emailSented === true ? 
                  <p>Mensagem recebida com sucesso.</p>
                  : 
                  this.state.recaptchaValid === false ?
                  
                    <button
                      disabled
                      className="backoffice-btn btn btn-outline-success"
                    >
                      Enviar Mensagem
                    </button>
                   : 
                   
                    <button
                      onClick={this.buttonClicked}
                      className="backoffice-btn btn btn-outline-success"
                    >
                      Enviar Mensagem
                    </button>
                   
                  }
                
                
              </div>

            </div>

          </div>
  
        </div>
      </section>
    )
  }

  captchaClicked = () => {
    this.setState({recaptchaValid: true});
  }

  buttonClicked = () => {
    
  
    let isFormValid = this.validateData();
  
    if (isFormValid){

      let data = {
        name: this.state.name,
        subject: this.state.subject,
        email: this.state.email,
        mensagem: this.state.mensagem
      }

      this.sendMessage(data);

    } else{
      
    }
  }

  sendMessage = async data => {
    let res = {};
    try {
      
      res = await pushDatatoServer("/api/mensagens", data, "post");
      
      if (
        res.response !== undefined &&
        res.response.data !== undefined &&
        res.response.data.errors !== undefined &&
        res.response.data.errors.length !== 0
      ) {
        
        //const missingFields = res.response.data["errors"];

      } else {
        this.setState({emailSented: true});
      }
    } catch (err) {
      
      console.log(err);
    }
  };


  validateData = () => { 
    
    let isFormValid = true;

    if (!this.validateField("name", "isNameValid")){
        isFormValid = false;
    };
    

    if (!this.validateEmail("email", "isEmailValid")){
      isFormValid = false;
    } 
    
    if (!this.validateField("mensagem", "isMensagemValid")){
      isFormValid = false;
    };

    if (!this.validateField("subject", "isSubjectValid")){
      isFormValid = false;
  };

    return isFormValid;
  }

  validateField = (field, isValidValue ) => {
    let newState = {};
    let isValid = true;
    let missingString = field+"Missing";

    if (this.state[field] === "" || this.state[field] === undefined || this.state[field].length===0){
        this.setState({[missingString]:true});
        isValid=false;
        console.log(this.state);
    } else{
        this.setState({[missingString]:''});
    }

    newState[isValidValue] = isValid;
    this.setState(newState);
    return isValid;
  }


  validateEmail = (field, isValidValue) => {
      
    let newState = {};
    let isValid = true;
    let missingString = field+"Missing";

    if (this.state[field] === "" || this.state[field] === undefined || this.state[field].length===0){
      this.setState({[missingString]:true});
      this.setState({"emailInvalid":false});
      isValid=false;
    } else{
        this.setState({[missingString]:''});
    }

    if(isValid){
      if(!this.validateEmailRegex(this.state[field])){
        
        isValid = false;
        this.setState({"emailInvalid":true});
      } else{
        
        isValid = true;
        this.setState({"emailInvalid":false});
      }
    }
    
    newState[isValidValue] = isValid;
    this.setState(newState);
    
    return isValid;

  }


  validateEmailRegex(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

}

Contacts.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Contacts);
